import i18n from "i18next";
import "../../../sass/components/BuyFlowAddOns.scss";
import AddAndRemoveButtons from "@/Pages/BuyFlow/AddAndRemoveButtons";
import {useEffect} from "react";

export default function AddOns({state, dispatch}) {

    useEffect(() => {
        state.cart.length > 0 && state.addOns.forEach((addOn) => {
            for (let item of state.cart) {
                autoAddAddonToCart(addOn, item);
            }
        })
    }, []);

    const overlap = (addOn) => {
        let addOnsInCart = state.cart.filter(item => item.type === "add-on");
        //max addOnsInCart length can only ever be 1 as only one addon allowed
        return addOnsInCart.length === 1 && addOnsInCart[0].name !== addOn.name;
    }

    /**
     * Determines whether an addon should be displayed to the user.
     *
     * @param addon
     * @param item
     *
     * @returns boolean
     */
    function shouldAddonBeDisplayed(addon, item) {
        return addon.productIds.includes(item.productId) && addon.productType.toLowerCase() !== 'usage';

    }

    /**
     * Auto adds an addon to the cart if it is required or if the product type === 'usage'
     *
     * @param addon
     * @param item
     *
     * @return boolean
     */
    function autoAddAddonToCart(addon, item) {
        if (addon.productIds.includes(item.productId) &&
            (addon.required || addon.productType.toLowerCase() === 'usage')) {
            dispatch({ type: "addToCart", payload: { addToCart: addon }});
            return true;
        }


        return false;
    }

    return (
        <div>

            {/*though a user can only access this component/page if they have a bundle*/}
            {/*or custom module in their cart, the state.cart.length check below is*/}
            {/*necessary for ensuring that the brief refresh and rerender with cookies*/}
            {/*allows time for the cart to populate and the code below to execute*/}

            {state.cart.length > 0 && state.addOns.map((addOn, index) => {
                for (let item of state.cart) {
                    if(shouldAddonBeDisplayed(addOn, item)) {
                        return <div className={`add-ons ${overlap(addOn) ? "disabled-add-on" : ""}`} key={index}>
                            <div className="add-on-title">{addOn.name}</div>
                            <span className="add-on-price">
                            ${addOn.price}
                        </span>
                            <span className="per-month">{i18n.t("buy-flow./one-time")}</span>
                            { !addOn.required && (
                                <AddAndRemoveButtons
                                    bundle={addOn}
                                    disabled={overlap(addOn)}
                                    state={state}
                                    dispatch={dispatch} />
                            )}
                        </div>
                    }
                }
            })}
        </div>
    )
}
